import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useId } from 'react-id-generator';
import styled from 'styled-components';
import { spacing6x, spacing2x } from '../../styles/spacing.js';
import { A11YLabel } from '../A11YLabel/A11YLabel.js';
import { Radio } from '../Radio/Radio.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["children", "groupName", "hideLabel", "label", "startAdornment"];
var Container = styled.div.withConfig({
  displayName: "RadioGroupItem__Container",
  componentId: "sc-y7b5qm-0"
})(["&&{display:flex;align-items:center;height:", ";}&& > label{cursor:pointer;}"], spacing6x);
var A11YLabelContainer = styled.label.withConfig({
  displayName: "RadioGroupItem__A11YLabelContainer",
  componentId: "sc-y7b5qm-1"
})(["&&{padding-inline-start:", ";}"], function (_ref) {
  var noPadding = _ref.noPadding;
  return noPadding ? 0 : spacing2x;
});
var RadioGroupItem = function RadioGroupItem(_ref2) {
  var _radioProps$id;
  _ref2.children;
    var groupName = _ref2.groupName,
    hideLabel = _ref2.hideLabel,
    label = _ref2.label,
    startAdornment = _ref2.startAdornment,
    radioProps = _objectWithoutProperties(_ref2, _excluded);
  var generatedId = useId(1, "_mntl-radio-group-item-")[0];
  var id = (_radioProps$id = radioProps.id) !== null && _radioProps$id !== void 0 ? _radioProps$id : generatedId;
  return /*#__PURE__*/jsxs(Container, {
    children: [/*#__PURE__*/jsx(Radio, _objectSpread(_objectSpread({}, radioProps), {}, {
      id: id,
      name: groupName
    })), /*#__PURE__*/jsx(A11YLabelContainer, {
      noPadding: !startAdornment && hideLabel,
      htmlFor: id,
      children: /*#__PURE__*/jsx(A11YLabel, {
        iconSize: 20,
        startAdornment: startAdornment,
        label: label,
        hideLabel: hideLabel
      })
    })]
  });
};
RadioGroupItem.displayName = "RadioGroupItem";

export { RadioGroupItem };
